const modalOpenButton = document.querySelector(".test__button");
const modalCloseButton = document.querySelector(".close-icon-wrapper");
const iphoneDialogOverlay = document.querySelector(".overlay.iphone-tradein");


modalOpenButton.addEventListener("click", () => {
  iphoneDialogOverlay.style.display = "flex";
});

modalCloseButton.addEventListener("click", () => {
  iphoneDialogOverlay.style.display = "none";
});

const getIphones = async () => {
  const res = await fetch(
    "https://macbro.uz/collections/smartfony-apple/products.json"
  );
  const data = await res.json();
  const lastAddedProducts = data.products.sort(
    (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
  );
  const lastThreeAddedProducts = lastAddedProducts.slice(0, 3);

  const onlyIphoneNames = data.products.map((item) => {
    return {title: item.title, price: item.variants[0].price};
  });

  return { onlyIphoneNames, lastThreeAddedProducts, allIphones: data.products };
};

const initTradeIn = async () => {
  const { onlyIphoneNames, lastThreeAddedProducts, allIphones } = await getIphones();

  const quizData = [
    {
      question: "Выбери свой IPhone",
      options: onlyIphoneNames,
      type: "selectOption",
      correctAnswer: "",
    },
    {
      question: "Включается и работает нормально?",
      options: ["Да", "Нет"],
      type: "multipleChoice",
      correctAnswer: "Да",
      percent: 7,
    },
    {
      question: "Все кнопки работают?",
      options: ["Да", "Нет"],
      type: "multipleChoice",
      correctAnswer: "Да",
      percent: 8,
    },
    {
      question: "Камеры работают все линзы не повреждены?",
      options: ["Да", "Нет"],
      type: "multipleChoice",
      correctAnswer: "Да",
      percent: 12,
    },
    {
      question: "Кузов без вмятин и царапин?",
      options: ["Да", "Нет"],
      type: "multipleChoice",
      correctAnswer: "Да",
      percent: 20,
    },
    {
      question: "Емкость батареи?",
      type: "textInput",
      correctAnswer: "",
      percent: 30,
    },
    {
      question: "Тачскрин и заднее стекло не повреждены?",
      options: ["Да", "Нет"],
      type: "multipleChoice",
      correctAnswer: "Да",
      percent: 14,
    },
    {
      question: "На дисплее нет искаженный линий и черных или белых пятен?",
      options: ["Да", "Нет"],
      type: "multipleChoice",
      correctAnswer: "Да",
      percent: 9,
    },
  ];

  let currentQuestionIndex = 0;
  let userAnswers = [];
  let selectedIPhone = null

  function loadQuestion() {
    const currentQuestion = quizData[currentQuestionIndex];
    const questionText = document.getElementById("question-text");
    const optionsContainer = document.getElementById("options-container");
    const nextBtn = document.getElementById("next-btn");
   

    questionText.textContent = currentQuestion.question;

    // Clear previous options
    optionsContainer.innerHTML = "";

    if (currentQuestion.type === "multipleChoice") {
      // Display multiple choice options
      nextBtn.style.display = "none";
      currentQuestion.options.forEach((option) => {
        const optionBtn = document.createElement("button");
        optionBtn.textContent = option;
        let percentage = 0;
        if (currentQuestion.correctAnswer === option) {
          percentage = currentQuestion.percent;
        }
        optionBtn.addEventListener("click", () =>
          handleOptionClick(percentage)
        );
        optionsContainer.appendChild(optionBtn);
      });
    } else if (currentQuestion.type === "textInput") {
      // Display text input for user to enter their age
      nextBtn.style.display = "flex";
      const input = document.createElement("input");
      input.type = "number";
      input.min = 70;
      input.addEventListener("blur", (e) => {
        if (e.target.value < 70) {
          input.value = 70;
        } else if (e.target.value > 100) {
          input.value = 100;
        }
      });

      let percentage = currentQuestion.percent;

      input.addEventListener("input", (e) => {
        const inputValue = e.target.value;
        if (inputValue >= 95 && inputValue <= 100) {
          percentage -= (percentage / 100) * 30;
        } else if (inputValue >= 90 && inputValue < 95) {
          percentage -= (percentage / 100) * 40;
        } else if (inputValue >= 85 && inputValue < 90) {
          percentage -= (percentage / 100) * 50;
        } else if (inputValue >= 80 && inputValue < 85) {
          percentage -= (percentage / 100) * 60;
        } else if (inputValue >= 75 && inputValue < 80) {
          percentage -= (percentage / 100) * 70;
        } else if (inputValue >= 70 && inputValue < 75) {
          percentage -= (percentage / 100) * 80;
        }
      });

      optionsContainer.appendChild(input);

      nextBtn.addEventListener("click", () => handleTextInput(percentage));
    } else if (currentQuestion.type === "selectOption") {
      // Display select options
      nextBtn.style.display = "flex";
      const select = document.createElement("select");
      currentQuestion.options.forEach((option) => {
        const optionElement = document.createElement("option");
        optionElement.value = option.title;
        optionElement['dataset'].price = parseFloat(option.price).toLocaleString();
        optionElement.textContent = option.title;
        select.appendChild(optionElement);
      });
      optionsContainer.appendChild(select);

      nextBtn.addEventListener("click", () => handleSelectOption(select.value));
    }

     const selectElement = document.querySelector("#options-container select")

    selectElement.addEventListener("change", () => {
       const selectedOption = selectElement.options[selectElement.selectedIndex];

     const dataAttributeValue = selectedOption.getAttribute("data-price");
     selectedIPhone = dataAttributeValue
    })
    
  }

  function handleOptionClick(selectedOption) {
    userAnswers.push(selectedOption);
    nextQuestion();
  }

  function handleTextInput(userInput) {
    userAnswers.push(userInput);
    nextQuestion();
  }

  function handleSelectOption(selectedOption) {
    userAnswers.push(selectedOption);
    nextQuestion();
  }

  function sumNumbers(arr) {
    let total = 0;

    for (let i = 0; i < arr.length; i++) {
      // Check if the current element is a number
      if (typeof arr[i] === "number") {
        // Add the number to the total
        total += arr[i];
      }
    }

    return total;
  }

  function nextQuestion() {
      const questionText = document.getElementById("question-text");
      questionText.style.fontSize = "44px"
    
    if (currentQuestionIndex < quizData.length) {
      currentQuestionIndex++;
      loadQuestion();
    } else {
      const optionsContainer = document.getElementById("options-container");

      questionText.innerHTML =
        `Получите Gift-Card до <b style="font-weight:bold">${selectedIPhone}</b> сум программой Trade-in для обмена вашего старого устройства и получите нового гаджета`;
      questionText.style.fontSize = "24px";
      questionText.style.fontWeight = "500";
      const percentageCorrect = sumNumbers(userAnswers);

      const productWrapper = document.createElement("div");
      const image = document.createElement("image");
      const productDetails = document.createElement("div");
      const productTitle = document.createElement("p");
      const selectButton = document.createElement("button");

      optionsContainer.innerHTML = "";

      lastThreeAddedProducts.forEach((product) => {
        optionsContainer.innerHTML += `
        <div class="result__product-wrapper">
          <img src="${product.images[0].src}" alt="${product.title}" >
          <div>
            <p>${product.title}</p>
          </div>
          <a href="https://macbro.uz/products/${product.handle}">Выбрать</a>
        </div>
        `;
      });
    }
  }

  // Initial load
  loadQuestion();
};

initTradeIn();
